import React, { useEffect, useState, useCallback } from "react";
import Background from "./Background";
import CustomSelection from "./CustomSelection";
import CarCard from "./CarCard";
import car1 from "../../assets/assets/images/home_images/home_grid1.png";
import car2 from "../../assets/assets/images/home_images/home_grid2.png";
import car3 from "../../assets/assets/images/home_images/home_grid3.png";
import car4 from "../../assets/assets/images/home_images/home_grid4.png";
import noData from "../../assets/no-data.png";
// import img from '../../assets/carlist-bg6.jpg'
import img from "../../assets/cars-bg4.jpg";
import { IoCarSportOutline, IoFilterOutline } from "react-icons/io5";
import FilterMobile from "./FilterMobile";
import { FormGroup, Pagination, Switch, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCars,
  getCars,
  clearCarCategoryId,
  filterCars,
} from "../../redux/Slice/carSlice";
import { fetchCarModal, getCategories } from "../../redux/Slice/configSlice";
import CarSearchForm from "../Navbar/CarSearchForm";
import { getCarMake } from "../../redux/Slice/formSlice";
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 50,
  height: 26,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(24px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 3,
    "&.Mui-checked": {
      transform: "translateX(24px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#008080 !important", // Track color when checked
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 20,
    height: 20,
    borderRadius: 15,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 15,
    opacity: 1,
    backgroundColor: "#424242 !important", // Track color when unchecked
    boxSizing: "border-box",
  },
}));

const Index = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const dispatch = useDispatch();
  const carList = useSelector((state) => state?.form?.cars);
  const categories = useSelector((state) => state?.config?.categories);
  const getCartData = useSelector((state) => state?.car?.getCartData);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  // const [isChecked, setIsChecked] = useState(false);
  const { carCategoryId, isFiltered } = useSelector((state) => state?.car);
  const searchQuery = useSelector((state) => state?.car?.searchQuery);
  const [filteredCars, setFilteredCars] = useState([]);
  let itemsPerPage = 6;
  const numberOfPages = Math.ceil(filteredCars?.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchFormQuery, setSearchFormQuery] = useState({});
  const [isSearched, setIsSearched] = useState(false);
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const [isChecked, setIsChecked] = useState(() => {
    const savedValue = sessionStorage.getItem("isChecked");
    return savedValue ? JSON.parse(savedValue) : false;
  });

  // Update session storage whenever isChecked changes
  useEffect(() => {
    sessionStorage.setItem("isChecked", JSON.stringify(isChecked));
  }, [isChecked]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // let currentPageData = filteredCars.slice(startIndex, endIndex);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [priceOrder, setPriceOrder] = useState(1);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setCurrentPage(1); // Reset to first page when filter changes
  };
  function checkUncheckfav(id) {
    const data = currentPageData?.map((ele) => {
      if (ele?._id === id) {
        if (!Array.isArray(ele.isUserFavId)) {
          ele.isUserFavId = [];
        }

        const userId = userDetail?.data?._id;
        const userIndex = ele.isUserFavId.indexOf(userId);

        let newIsUserFavId;
        if (userIndex !== -1) {
          // Remove userId if it exists
          newIsUserFavId = ele.isUserFavId.filter((uid) => uid !== userId);
        } else {
          // Add userId if it doesn't exist
          newIsUserFavId = [...ele.isUserFavId, userId];
        }

        return {
          ...ele,
          isUserFavId: newIsUserFavId,
        };
      }

      return ele;
    });
    setCurrentPageData(data);
  }

  useEffect(() => {
    setCurrentPageData(filteredCars?.slice(startIndex, endIndex));
  }, [startIndex, endIndex, filteredCars]);
  useEffect(() => {
    dispatch(getCategories());
    // dispatch(getCars());   //static payload
    if (!searchQuery?.filterQuery) dispatch(getAllCars());
    dispatch(getCarMake());
    dispatch(fetchCarModal());
    return () => {
      dispatch(clearCarCategoryId());
    };
  }, []);
  // useEffect(() => {
  //   dispatch(
  //     filterCars({
  //       filterQuery: {
  //         carType: [],
  //         carmaker: [],
  //         carmodel: [],
  //         numberOfSeats: [],
  //         fuelType: [],
  //       },
  //       // userId: "661a5a9e155539e4bf273268",
  //       userId: userDetail?.data?._id,
  //       userLat: "",
  //       userLong: "",
  //       pickUpDateandTime: "",
  //       returnDateandTime: "",
  //       price: -1,
  //       withDriver: isChecked,
  //     })
  //   );
  // }, []);
  useEffect(() => {
    const filterCars = () => {
      if (!isFiltered && carCategoryId !== "") {
        // for driver check
        // if (isChecked) {
        //   return getCartData?.data?.filter(
        //     (item) =>
        //       userDetail?.data?._id !== item?.userId &&
        //       item?.withDriver &&
        //       carCategoryId === item?.carCategoryId?._id
        //   );
        // } else {
        //   return getCartData?.data?.filter(
        //     (item) =>
        //       userDetail?.data?._id !== item?.userId &&
        //       carCategoryId === item?.carCategoryId?._id
        //   );
        // }
        return getCartData?.data?.filter(
          (item) =>
            userDetail?.data?._id !== item?.userId &&
            carCategoryId === item?.carCategoryId?._id
        );
      } else {
        // if (isChecked) {
        //   return getCartData?.data?.filter(
        //     (item) => userDetail?.data?._id !== item?.userId && item?.withDriver
        //   );
        // } else {
        //   return getCartData?.data?.filter(
        //     (item) => userDetail?.data?._id !== item?.userId
        //   );
        // }
        return getCartData?.data?.filter(
          (item) => userDetail?.data?._id !== item?.userId
        );
      }
    };

    const filteredCarsData = filterCars();

    const allFiltersEmpty = !(
      searchFormQuery?.carMake?.length ||
      searchFormQuery?.carModel?.length ||
      searchFormQuery?.fuelType?.length
    );

    const filteredCarswithQuery = allFiltersEmpty
      ? filteredCarsData
      : filteredCarsData.filter((car) => {
          // Check if car's maker._id is in searchFormQuery.carMake array (if it exists and has length)
          if (
            searchFormQuery?.carMake?.length &&
            !searchFormQuery.carMake.includes(car?.maker._id)
          ) {
            return false;
          }

          // Check if car's model._id is in searchFormQuery.carModel array (if it exists and has length)
          if (
            searchFormQuery?.carModel?.length &&
            !searchFormQuery.carModel.includes(car?.model._id)
          ) {
            return false;
          }

          // Check if car's fuelType is in searchFormQuery.fuelType array (if it exists and has length)
          if (
            searchFormQuery?.fuelType?.length &&
            !searchFormQuery.fuelType.includes(car?.fuelType)
          ) {
            return false;
          }

          // If all conditions pass, include the car in filtered results
          return true;
        });
    const sortCarsByPrice = (cars, order) => {
      if (cars) {
        if (+order === -1) {
          return cars?.sort(
            (car1, car2) => car2?.pricePerDay - car1?.pricePerDay
          ); // Descending order
        } else if (+order === 1) {
          return cars?.sort(
            (car1, car2) => car1?.pricePerDay - car2?.pricePerDay
          ); // Ascending order
        }
      }

      return cars; // Return original array if order is 0 or undefined
    };

    if (isSearched) {
      const sortedQueryCars = sortCarsByPrice(
        filteredCarswithQuery,
        priceOrder
      );
      setFilteredCars(sortedQueryCars);
    } else {
      const sortedDataCars = sortCarsByPrice(filteredCarsData, priceOrder);
      setFilteredCars(sortedDataCars);
    }
  }, [
    isFiltered, // added for removing car category id filter when search by user
    carCategoryId,
    isChecked,
    getCartData,
    userDetail,
    searchFormQuery,
    priceOrder,
  ]);

  // const sortByPriceHandler = useCallback((type) => {
  //   setPriceOrder(type);
  //   var sortedPriceCars;
  //   if (type === "Low to High") {
  //     sortedPriceCars = [...currentPageData]?.sort(
  //       (a, b) => a?.pricePerDay - b?.pricePerDay
  //     );
  //   } else {
  //     sortedPriceCars = [...currentPageData]?.sort(
  //       (a, b) => b?.pricePerDay - a?.pricePerDay
  //     );
  //   }

  //   setCurrentPageData(sortedPriceCars);
  // }, []);

  return (
    <div className="mb-5">
      <Background image={img} name="Cars" />

      <CarSearchForm setCurrentPage={setCurrentPage} />

      <div className="container-xxl">
        <div className="d-flex justify-content-center align-items-center mt-5 mt-md-5 mb-3 mb-md-5">
          {/* <div className="search-local text-center">
            <div className="icon">
              <IoCarSportOutline />
            </div>
            <input type="text" placeholder="Looking for a specific car?" />
            <button className='search-btn' >
              <FiSearch className='search-btn-icon' />
            </button>
          </div> */}
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="filter-btn">
              <div
                className="modal fade"
                id="filterModal"
                tabIndex="-1"
                aria-labelledby="filterModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content px-sm-3 px-2">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="filterModalLabel">
                        Filter
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <CustomSelection
                        setIsSearched={setIsSearched}
                        setSearchFormQuery={setSearchFormQuery}
                        setCurrentPage={setCurrentPage}
                        isChecked={isChecked}
                        setPriceOrder={setPriceOrder}
                        // sortByPriceHandler={sortByPriceHandler}
                        // categories={categories}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 px-sm-0 px-md-2">
            <div className="mb-4 mx-3">
              <div className="d-flex mb-2 justify-content-between align-items-center">
                <h2 className="font secondaryColor">Available Near You</h2>
                <button
                  type="button"
                  className="btn filter-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#filterModal"
                >
                  <IoFilterOutline />
                </button>
              </div>
              {/* <div className="d-flex flex-row gap-5 align-items-center">
                <p>With Driver</p>

                <AntSwitch
                  onChange={handleCheckboxChange}
                  checked={isChecked}
                  inputProps={{ "aria-label": "ant design" }}
                />
              </div> */}
            </div>
            <div className="row g-4 mx-0" name="searchResult">
              {/* {carList?.map((car) => {
                return <div className='col-md-6' key={car?._id} >
                    <CarCard
                      available={car?.available}
                      image={car1}
                      carName={car?.model}
                      rating="4"
                      seater={car?.seatingCapacity}
                      price={car?.pricePerDay
                      }
                    />
                </div>
              })} */}

              {/* {
                carCategoryId !== "" ?
                  <>
                    {isChecked ?
                      <>
                        {
                          getCartData?.data?.map((item, index) => {
                            if (userDetail?.data?._id !== item?.userId) {
                              if (item?.withDriver) {
                                if (carCategoryId === item?.carCategoryId?._id) {
                                  return (
                                    <div className='col-md-6 col-lg-4' key={item?._id + index} >
                                      <CarCard
                                        data={item}
                                        image={`${baseURL}${item?.frontImage}`}
                                        carName={item?.maker?.carMake}
                                        rating={item?.averageRating}
                                        seater={item?.numberOfSeats}
                                        price={item?.pricePerDay}
                                      />
                                    </div>
                                  )
                                }

                              }

                            }
                          })
                        }
                      </>
                      :
                      <>
                        {
                          getCartData?.data?.map((item, index) => {
                            if (userDetail?.data?._id !== item?.userId) {
                              if (carCategoryId === item?.carCategoryId?._id) {
                                return (
                                  <div className='col-md-6 col-lg-4' key={item?._id + index} >
                                    <CarCard
                                      data={item}
                                      image={`${baseURL}${item?.frontImage}`}
                                      carName={item?.maker?.carMake}
                                      rating={item?.averageRating}
                                      seater={item?.numberOfSeats}
                                      price={item?.pricePerDay}

                                    />
                                  </div>
                                )
                              }

                            }
                          })
                        }
                      </>
                    }
                  </>
                  :
                  <>
                    {isChecked ?
                      <>
                        {
                          getCartData?.data?.map((item, index) => {
                            if (userDetail?.data?._id !== item?.userId) {
                              if (item?.withDriver) {
                                return (
                                  <div className='col-md-6 col-lg-4' key={item?._id + index} >
                                    <CarCard
                                      data={item}
                                      image={`${baseURL}${item?.frontImage}`}
                                      carName={item?.maker?.carMake}
                                      rating={item?.averageRating}
                                      seater={item?.numberOfSeats}
                                      price={item?.pricePerDay}
                                    />
                                  </div>
                                )
                              }

                            }
                          })
                        }
                      </>
                      :
                      <>
                        {
                          getCartData?.data?.map((item, index) => {
                            if (userDetail?.data?._id !== item?.userId) {
                              return (
                                <div className='col-md-6 col-lg-4' key={item?._id + index} >
                                  <CarCard
                                    data={item}
                                    image={`${baseURL}${item?.frontImage}`}
                                    carName={item?.maker?.carMake}
                                    rating={item?.averageRating}
                                    seater={item?.numberOfSeats}
                                    price={item?.pricePerDay}

                                  />
                                </div>
                              )
                            }
                          })
                        }
                      </>
                    }
                  </>

              } */}

              {currentPageData?.map((item, index) => {
                return (
                  <div className="col-md-6 col-lg-4" key={item?._id + index}>
                    <CarCard
                      checkUncheckfav={checkUncheckfav}
                      data={item}
                      image={`${baseURL}${item?.frontImage}`}
                      carName={item?.maker?.carMake}
                      rating={item?.averageRating}
                      seater={item?.numberOfSeats}
                      price={item?.pricePerDay}
                    />
                  </div>
                );
              })}
              {currentPageData?.length === 0 ? (
                <div className="d-flex justify-content-center">
                  {/* <h2 className="text-center font secondaryColor mt-3">
                    No data found
                  </h2> */}
                  <img
                    src={noData}
                    alt="no data found"
                    className="nofoundImg"
                  />
                </div>
              ) : null}

              {/* <div className='col-md-6 col-lg-4' >
                <CarCard

                  image={car2}
                  carName="Audi A8 L"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div>
              <div className='col-md-6 col-lg-4' >
                <CarCard
                  image={car3}
                  carName="kia Carens"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div>
              <div className='col-md-6 col-lg-4' >
                <CarCard

                  image={car4}
                  carName="Toyota glanza"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div>
              <div className='col-md-6 col-lg-4' >
                <CarCard


                  image={car1}
                  carName="Mercedes Benz"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div>
              <div className='col-md-6 col-lg-4' >
                <CarCard


                  image={car2}
                  carName="Audi A8 L"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div>
              <div className='col-md-6 col-lg-4' >
                <CarCard
                  image={car3}
                  carName="kia Carens"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div>
              <div className='col-md-6 col-lg-4' >
                <CarCard


                  image={car4}
                  carName="Toyota glanza"
                  rating="4"
                  seater="5"
                  price="220"

                />
              </div> */}
            </div>
          </div>
        </div>
        <div className="mt-4 text-end">
          <Pagination
            count={numberOfPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
